import { fetchGraphQL } from "./libs";
const setTopNews = async () => {
  const container = document.querySelector('#js-p-top-news-container');
  if (!container) return false;

  const GET_POSTS = `
    {
      posts(first: 5) {
        edges {
          node {
            link
            title
            date
            categories(first: 1) {
              edges {
                node {
                  name
                  categorySettings {
                    bgColor
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const res = await fetchGraphQL(GET_POSTS, { first: 5 }),
    targetData = res.posts.edges;

  let html = ``;

  if (targetData) {
    html += `
                <ul class="p-top-news__list">`;

    targetData.forEach(data => {
      const link = data.node.link,
        title = data.node.title,
        timestamp = new Date(data.node.date),
        year = timestamp.getFullYear(),
        month = (timestamp.getMonth() + 1).toString().padStart(2, '0'),
        date = timestamp.getDate().toString().padStart(2, '0'),
        category = data.node.categories.edges[0].node;

      console.log(date)

      html += `
                  <li class="p-top-news__item">
                    <a href="${link}" class="p-top-news__link">
                      <time datetime="${year}-${month}-${date}" class="p-top-news__time">${year}.${month}.${date}</time>
                      <div class="p-top-news__cat" style="background-color: ${category.categorySettings.bgColor};">${category.name}</div>
                      <p class="p-top-news__subject">${title}</p>
                    </a>
                  </li>
        `;
    });

    html += `
                </ul>`;
  }

  container.innerHTML = html;
};

export default setTopNews;